var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.8463 3.17025C57.7469 1.14038 63.2531 1.14037 68.1537 3.17025L95.2727 14.4033C100.173 16.4332 104.067 20.3267 106.097 25.2273L117.33 52.3463C119.36 57.2469 119.36 62.7531 117.33 67.6537L106.097 94.7727C104.067 99.6733 100.173 103.567 95.2727 105.597L68.1537 116.83C63.2531 118.86 57.7469 118.86 52.8463 116.83L25.7273 105.597C20.8267 103.567 16.9332 99.6733 14.9033 94.7727L3.67025 67.6537C1.64038 62.7531 1.64037 57.2469 3.67025 52.3463L14.9033 25.2273C16.9332 20.3267 20.8267 16.4332 25.7273 14.4033L52.8463 3.17025Z",
    fill: "#1E016F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8463 13.1703C57.7469 11.1404 63.2531 11.1404 68.1537 13.1703L88.2017 21.4744C93.1022 23.5043 96.9957 27.3978 99.0256 32.2983L107.33 52.3463C109.36 57.2469 109.36 62.7531 107.33 67.6537L99.0256 87.7017C96.9957 92.6022 93.1022 96.4957 88.2017 98.5256L68.1537 106.83C63.2531 108.86 57.7469 108.86 52.8463 106.83L32.7983 98.5256C27.8978 96.4957 24.0043 92.6022 21.9744 87.7017L13.6703 67.6537C11.6404 62.7531 11.6404 57.2469 13.6703 52.3463L21.9744 32.2983C24.0043 27.3978 27.8978 23.5043 32.7983 21.4744L52.8463 13.1703Z",
    fill: "#7647EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 60L54.5 72L78.5 48",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.01ad550a1654d6c9ade72f98373a4e66.svg";
export { ForwardRef as ReactComponent };